import { observer } from 'mobx-react-lite';
import React from 'react';
import { getMediaUploadSummary } from '../../../../data';
import { getPercentage } from '../../../../stores/utils';
import { ItemTitle, ListItemSummary, SVGCircle } from '../../index';
import { SmallChart } from '../Styles';

const formatCommas = (value) => new Intl.NumberFormat().format(value);

export const TotalMediaUploads = observer(
  ({
    auctionID,
    itemName,
    totalItems,
    totalItemsError,
    totalItemsPending,
    totalItemsUploaded,
  }) => {
    return (
      <>
        <div className="top">
          <ItemTitle
            testId="media-state-breakdown-label"
            textSize={1.1}
            titleText="Total Media Uploads:"
          />
        </div>
        <div className="bottom">
          <ListItemSummary
            itemList={getMediaUploadSummary(
              formatCommas(totalItemsUploaded),
              formatCommas(totalItemsPending),
              formatCommas(totalItemsError),
              auctionID,
              itemName,
              'left center',
            )}
            key={`mediaSum_${auctionID}`}
            testId="media-state-buttons"
          />
          <SmallChart style={{ marginTop: '-30px' }}>
            <SVGCircle
              auctionID={auctionID}
              auctionName={itemName}
              chartError={totalItemsError > 0}
              clickRoute={`/auction/${auctionID}/productImages/`}
              percentvalue={getPercentage(totalItemsUploaded, totalItems)}
              popupHeader="Product Images"
              popupPosition="right center"
              testId={`auction-images-breakdown-${auctionID}`}
              text={`${
                formatCommas(totalItemsUploaded) +
                '/' +
                formatCommas(totalItems)
              }`}
            />
          </SmallChart>
        </div>
      </>
    );
  },
);

export default TotalMediaUploads;
